import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../../style/styles";
import { formatSettlementPaymentCurrency } from "../helpers/functions";

export default function SettlementPaymentsModalHeader({ title, caseDetail }) {
  return (
    <div className="px-6 pt-6">
      <Typography
        className="text-[20px]"
        sx={SETTLEMENT_STYLES.modalTitle}
      >
        {title}
      </Typography>
      <div className="mt-3 flex flex-wrap gap-x-8 gap-y-1 text-[14px]">
        <Typography sx={SETTLEMENT_STYLES.modalMetaText}>
          Law Firm:{" "}
          <span style={{ color: HNSColors.neutrals[100] }}>
            {caseDetail?.lawFirmName ?? caseDetail?.law_firm_name ?? "N/A"}
          </span>
        </Typography>
        <Typography sx={SETTLEMENT_STYLES.modalMetaText}>
          Settlement Amount:{" "}
          <span style={{ color: HNSColors.neutrals[100] }}>
            {formatSettlementPaymentCurrency(
              caseDetail?.actualTotalSettlementAmount ??
                caseDetail?.actual_total_settlement_amount ??
                0
            )}
          </span>
        </Typography>
      </div>
    </div>
  );
}
